import React, { Component } from 'react'
import { Router } from 'react-router-dom'
import 'echarts-wordcloud'

import { connect } from 'react-redux'
import * as userInfoActions from './v2/actions/userInfo'
import { bindActionCreators } from 'redux'

import 'bootstrap/dist/css/bootstrap.min.css'
import './appkit3-react.default.css'
import i18next from 'i18next'

import './constants.css'
import '@appkit4/styles/appkit.min.css'
import '@appkit4/react-components/dist/styles/appkit4-react.min.css'
import './App.css'

// NOTE: コンポーネントのCSSがAppkit4のCSSに負けることがあるため一番下に記載
import { CustomRoutes as Routes, history } from './v2/routers'

// 端末がPCの場合
class App extends Component {
    componentDidMount() {
        const lang = i18next.getLang()
        i18next.setLang(lang)
    }

    render() {
        return (
            <React.Suspense fallback={null}>
                <Router history={history}>
                    <Routes userInfo={this.props.userInfo} />
                </Router>
            </React.Suspense>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        userInfoActions: bindActionCreators(userInfoActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
